import { render, staticRenderFns } from "./cominfo-list.vue?vue&type=template&id=eb4bca28&"
import script from "./cominfo-list.vue?vue&type=script&lang=js&"
export * from "./cominfo-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cominfo-list.vue"
export default component.exports